import styled from 'styled-components';
import Button from 'components/Button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  background-color: ${(props) => props.theme.colors['white']};
  border-radius: 10px;
  min-height: 73px;

  .notebook-online-main-container {
    @media (min-width: 845px) {
      row-gap: 30px;
    }
  }

  .titleContainer {
    padding: 20px 20px 0;
  }

  @media (max-width: 1500px) {
    .lastMarketOnlineNbRestaurantTitle {
      font-size: 0.7rem;
    }

    .lastMarketOnlineNbRestaurantNumber {
      font-size: 2.8rem;
    }
  }
`;

const ButtonContainer = styled(Button).attrs((props) => ({
  type: 'round',
  icon: 'loadingArrow',
  color: props.theme.colors['terra-cotta'],
  iconColor: props.theme.colors['white']
}))`
  width: 33px;
  height: 33px;

  span {
    width: 13px;
    height: 13px;
  }
`;

export default Container;
export { ButtonContainer };
